import { Injectable } from '@angular/core';
import { Apollo } from "apollo-angular";
import Fund from "../../interfaces/fund";
import { BehaviorSubject, Subscription } from "rxjs";
import OutletReviewStatus from "../../interfaces/outlet-review-status";
import OutletReviewCategory from "../../interfaces/outlet-review-category";
import ID from "../../types/id";
import {
  GET_REVIEW_TIMELINE,
  UPDATE_OUTLET_REVIEW_TRACKER,
  UpdateOutletReviewTrackerInput
} from "./graphql/review-timeline";
import Status from "../../interfaces/status";
import FundType from "../../interfaces/fund-type";
import { DefaultSnackBarService } from "../../services/default-snack-bar.service";
import OutletReviewTracker from "../../interfaces/outlet-review-tracker";
import Permission from "../../interfaces/permission";

@Injectable({
  providedIn: 'root'
})
export class ReviewTimelineService {

  private _fund: Fund|null = null;
  private fund = new BehaviorSubject(this._fund);
  public fund$ = this.fund.asObservable();

  private _outletReviewStatuses:OutletReviewStatus[] = [];
  private outletReviewStatuses = new BehaviorSubject(this._outletReviewStatuses);
  public outletReviewStatuses$ = this.outletReviewStatuses.asObservable();

  private _outletReviewCategories:OutletReviewCategory[] = [];
  private outletReviewCategories = new BehaviorSubject(this._outletReviewCategories);
  public outletReviewCategories$ = this.outletReviewCategories.asObservable();

  private _trackers:OutletReviewTracker[] = [];
  private trackers = new BehaviorSubject(this._trackers);
  public trackers$ = this.trackers.asObservable();

  private _statuses: Status[] = [];
  private statuses = new BehaviorSubject(this._statuses);
  public statuses$ = this.statuses.asObservable();

  private _fundTypes: FundType[] = [];
  private fundTypes = new BehaviorSubject(this._fundTypes);
  public fundTypes$ = this.fundTypes.asObservable();

  private _permissions: Permission|null = null;
  private permissions = new BehaviorSubject(this._permissions);
  public permissions$ = this.permissions.asObservable();


  constructor(public apollo: Apollo, private _snackBar: DefaultSnackBarService) { }

  private _setPermissions(permissions: Permission) {
    this._permissions = permissions;
    this.permissions.next(this._permissions);
  }

  private _setTrackers(trackers: OutletReviewTracker[]){
    this._trackers = trackers;
    this.trackers.next(this._trackers);
  }

  private _setFund(fund: Fund) {
    this._fund = fund;
    this.fund.next(this._fund);
    if(fund.outletReviewTrackers)
      this._setTrackers(fund.outletReviewTrackers);
  }
  private _setOutletReviewStatuses(outletReviewStatuses: OutletReviewStatus[]) {
    this._outletReviewStatuses = outletReviewStatuses;
    this.outletReviewStatuses.next(this._outletReviewStatuses);
  }
  private _setOutletReviewCategories(outletReviewCategories: OutletReviewCategory[]) {
    this._outletReviewCategories = outletReviewCategories;
    this.outletReviewCategories.next(this._outletReviewCategories);
  }
  private _setFundTypes(fundTypes: FundType[]) {
    this._fundTypes = fundTypes;
    this.fundTypes.next(this._fundTypes);
  }
  private _setStatuses(statuses: Status[]) {
    this._statuses = statuses;
    this.statuses.next(this._statuses);
  }
  public getReviewTrackerData(fund_id: ID){
    let sub:Subscription;
    sub = this.apollo.query({query:GET_REVIEW_TIMELINE, variables:{fund_id}}).subscribe(({data})=>{
      if(data?.fund){
        this._setFund(data.fund);
      }
      if(data?.outletReviewCategories){
        this._setOutletReviewCategories(data.outletReviewCategories);
      }
      if(data?.outletReviewStatuses){
        this._setOutletReviewStatuses(data.outletReviewStatuses);
      }
      if(data?.statusesBySequence){
        this._setStatuses(data?.statusesBySequence);
      }
      if(data?.me?.permissionsForResource){
        this._setPermissions(data.me.permissionsForResource);
      }
      sub?.unsubscribe();
    });
  }
  public updateOutletTimelineTracker(id: ID, input: UpdateOutletReviewTrackerInput) {
    let sub:Subscription;

    sub = this.apollo.mutate({mutation: UPDATE_OUTLET_REVIEW_TRACKER, variables: {id, input}}).subscribe(({data, loading})=>{
      if(data?.updateOutletReviewTracker){
          let index = this._trackers.findIndex((tracker) => tracker.id === data.updateOutletReviewTracker.id);
          if (index > -1) {
            let trackers = [...this._trackers]
            trackers[index] = data?.updateOutletReviewTracker;
            this._setTrackers(trackers);
          }
          this._snackBar.open("Successfully updated review tracker records.")
      }
      sub?.unsubscribe();
    });
  }
}
